import React from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "components/Navbar.js";
import Footer from "components/Footer.js";
import bridalPhoto from "../assets/img/rate-chart/bridal.jpg";
import partyPhoto from "../assets/img/rate-chart/party.jpg";
import hairstylePhoto from "../assets/img/rate-chart/hairstyle.jpg";
import { WHATSAPP_BOOKING_URL } from "../utils/contactDetails";
import "../styles/rate-chart.css";

const categories = [
  {
    title: "Bridal makeup",
    icon: "fa-crown",
    image: bridalPhoto,
    imageAlt: "Bridal makeup look",
    services: [
      { name: "Bridal makeup", price: "₹5,500", detail: "per function" },
      { name: "Engagement makeup", price: "₹3,500", detail: "per function" },
      { name: "Reception makeup", price: "₹5,500", detail: "per function" },
    ],
  },
  {
    title: "Party makeup",
    icon: "fa-star",
    image: partyPhoto,
    imageMode: "contain",
    imageAlt: "Party look from Arpita's Makeover portfolio",
    services: [
      { name: "Western & party makeup", price: "₹2,000", detail: "per look" },
      { name: "Guest makeup", price: "₹1,500", detail: "per person" },
    ],
  },
  {
    title: "Hair styling",
    icon: "fa-cut",
    image: hairstylePhoto,
    imageAlt: "Bridal hairstyle from Arpita's Makeover portfolio",
    services: [
      {
        name: "Hairstyle & saree draping",
        price: "₹1,500",
        detail: "per booking",
      },
    ],
  },
];

export default function RateChart() {
  return (
    <>
      <Helmet>
        <title>Rate Chart | Arpita's Makeover</title>
        <meta
          name="description"
          content="View bridal, reception, engagement, party makeup, hairstyling, and guest makeup rates from Arpita's Makeover."
        />
      </Helmet>
      <Navbar />
      <main className="rate-chart-page">
        <div className="rate-chart-sheet">
          <header className="rate-chart-heading">
            <span className="rate-chart-ornament" aria-hidden="true">
              <span />
              <i className="fas fa-gem" />
              <span />
            </span>
            <p className="rate-chart-brand">Arpita's Makeover</p>
            <h1>
              <span className="rate-chart-title-main">Makeup Artist</span>
              <span className="rate-chart-title-script">Price List</span>
            </h1>
            <span className="rate-chart-divider" aria-hidden="true">
              <span />
              <i className="fas fa-leaf" />
              <span />
            </span>
            <p className="rate-chart-subtitle">
              Thoughtful looks for your most special occasions
            </p>
          </header>

          <div className="rate-chart-ribbon">Makeup application</div>

          <section className="rate-chart-categories" aria-label="Service rates">
            {categories.map((category) => (
              <article className="rate-category" key={category.title}>
                <div
                  className={`rate-category-portrait${
                    category.imageMode === "contain"
                      ? " rate-category-portrait--contain"
                      : ""
                  }`}
                >
                  <img
                    src={category.image}
                    alt={category.imageAlt}
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="rate-portrait-corner" aria-hidden="true">
                    <i className={`fas ${category.icon}`} />
                  </span>
                </div>

                <div className="rate-category-content">
                  <h2>
                    <span className="rate-heading-flower" aria-hidden="true">
                      ✦
                    </span>
                    {category.title}
                    <span className="rate-heading-flower" aria-hidden="true">
                      ✦
                    </span>
                  </h2>
                  <ul className="rate-service-list">
                    {category.services.map((service) => (
                      <li className="rate-service-row" key={service.name}>
                        <span className="rate-service-name">
                          {service.name}
                          <small>{service.detail}</small>
                        </span>
                        <span className="rate-service-leader" aria-hidden="true" />
                        <span className="rate-service-price">{service.price}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </section>

          <footer className="rate-chart-footer">
            <p>
              Prices are starting rates. Please get in touch to discuss your
              preferred look and event details.
            </p>
            <div className="rate-chart-actions">
              <a
                href={WHATSAPP_BOOKING_URL}
                className="rate-chart-book"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Book your date on WhatsApp"
              >
                <i className="fab fa-whatsapp" aria-hidden="true" />
                Book your date
              </a>
              <a href="tel:9932142591" className="rate-chart-contact">
                <i className="fas fa-phone" aria-hidden="true" />
                Call to enquire
              </a>
            </div>
            <span className="rate-chart-footer-ornament" aria-hidden="true">
              — &nbsp; Made for your special day &nbsp; —
            </span>
          </footer>
        </div>
      </main>
      <Footer />
    </>
  );
}
